/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";

// return '' if item.chep?
// # displaying Unknown if job item has not be touch
// return UNKNOWN if loaded_quantity.nil? && unloaded_quantity.nil?
//
// job_status = UNKNOWN
//
// if job.delivery?
//   if loaded_quantity.present? && unloaded_quantity.present? && loaded_quantity.to_i == unloaded_quantity.to_i
//     # NGT-2217 special case to handle items not picked up during load verification and therefore not delivered
//     if loaded_quantity.to_i == 0 && unloaded_quantity.to_i == 0 && loaded_variance_code.present?
//       job_status = DELIVERY_NONE
//     else
//       job_status = DELIVERY_COMPLETE
//     end
//   elsif loaded_quantity.present? && unloaded_quantity.present? && loaded_quantity.to_i > unloaded_quantity.to_i
//     job_status = unloaded_quantity == 0 ? DELIVERY_NONE : DELIVERY_PARTIAL
//   elsif unloaded_quantity.present? && unloaded_quantity.to_i >= original_quantity.to_i # applicable for projects without loading process i.e. iPlex
//     job_status = DELIVERY_COMPLETE
//   elsif loaded_quantity.nil? && original_quantity.to_i > unloaded_quantity.to_i
//     job_status = unloaded_quantity == 0 ? DELIVERY_NONE : DELIVERY_PARTIAL
//   end
// elsif job.pickup?

// elsif job.depot?
//   job_status = %w(CHECKED).include?(status) ? DEPOT_CHECKED : '' # CHECKED if scanned or ticked
// end
// STATUSES = [
//       UNKNOWN = 'Unknown',
//       COMPLETED = 'Completed', (not even used)
//       DELIVERY_NONE = 'Non-Delivered', DELIVERY_PARTIAL = 'Partial', DELIVERY_COMPLETE = 'Delivered',
//       PICKUP_NONE = 'Non-Pickup', PICKUP_PARTIAL = 'Partial', PICKUP_COMPLETE = 'Picked Up',
//       DEPOT_CHECKED = 'Checked'
//   ]
const PickUpStatus = ({ jobItem }) => {
  //   if loaded_quantity.to_i >= original_quantity.to_i
  //     job_status = PICKUP_COMPLETE
  //   elsif original_quantity.to_i > loaded_quantity.to_i
  //     if job.completed?
  //       job_status = loaded_quantity.to_i == 0 ? PICKUP_NONE : PICKUP_PARTIAL
  //     else
  //       job_status = UNKNOWN
  //     end
  //   end
  let status;
  const loadedQuantity = jobItem.loadedQuantity;
  const originalQuantity = jobItem.originalQuantity;
  if (loadedQuantity >= originalQuantity) {
    status = "Picked Up";
  }
  if (loadedQuantity < originalQuantity) {
    status = "Non-Pickup";
  }

  return status;
};

const DeliveryStatus = ({ jobItem }) => {
  let status;
  const unloadedQuantity = jobItem.unloadedQuantity;
  const originalQuantity = jobItem.originalQuantity;
  if (unloadedQuantity === originalQuantity) {
    status = "Delivered";
  }
  if (unloadedQuantity < originalQuantity) {
    if (unloadedQuantity === 0) {
      status = "Non-Delivered";
    } else {
      status = "Partially Delivered";
    }
  }
  if (unloadedQuantity > originalQuantity) {
    status = "Excess Delivered";
  }

  return status;
};
DeliveryStatus.propTypes = {
  jobItem: PropTypes.object.isRequired
};

const JobItemStatus = ({ job, jobItem }) => {
  if (job.status === "COMPLETED") {
    if (job.type === "PICKUP") {
      return <PickUpStatus jobItem={jobItem} />;
    }

    return <DeliveryStatus jobItem={jobItem} />;
  }

  return "";
};
JobItemStatus.propTypes = {
  job: PropTypes.object.isRequired,
  jobItem: PropTypes.object.isRequired
};

export default JobItemStatus;



// WEBPACK FOOTER //
// ./src/components/jobs/helpers/JobItemStatus.js